import React, { useEffect, useRef, useState } from 'react'
import { Table, message } from 'antd'
import { ColumnsType } from 'antd/es/table'
import useGlobalModel from '@/model/globalModel'
import { vehiclePowerList } from '@/types/AppEnums'
import { YHModal } from '@/components/YHModal'
import { EditableRow, EditableCell } from '@/components/YHEditTable/editTable'
import { baseVehicleModel } from '../vehicleModel'
import { globalPrompt } from '@/components/message'
import { vehicleService } from '../vehicleService'
import moment from 'moment'

export const AddVehicleModal = () => {
    const [dataSource, setDataSource] = useState<any>([])
    const { addCarVisible, setAddCarVisible, loadData } = baseVehicleModel()
    const formRef = useRef<any>()
    const {
        authData,
        user: { shopCode, userType, createUser },
        companyData,
        fleetData
    } = useGlobalModel(({ user }) => [user])
    const [saveLoading, setSaveLoading] = useState<boolean>(false) //  保存按钮
    useEffect(() => {
        setDataSource([{
            temporaryId: new Date().getTime() + Math.floor(Math.random() * 10000),
            type: '卡车',
            createUserId: shopCode,
            createUser: createUser
        }])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addCarVisible])
    useEffect(() => {
        formRef.current = dataSource
    }, [dataSource])
    const DeleteRow = (record: any) => {
        const data = formRef.current.filter((i: any) => (record.temporaryId !== i.temporaryId))
        setDataSource(data)
    }
    const AddRow = (record: any) => {
        const dataIndex = formRef.current.findIndex((i: any) => (record.temporaryId === i.temporaryId))
        const newData = dataSource
        newData.splice(dataIndex + 1, 0, {
            temporaryId: new Date().getTime() + Math.floor(Math.random() * 10000),
            type: '卡车',
            createUserId: shopCode,
            createUser: createUser
        })
        setDataSource([...newData])
    }
    const columns = [
        {
            title: '操作',
            width: 140,
            fixed: 'left',
            align: 'center',
            render: (_t: any, r: any) =>
                <>
                    {dataSource.length > 1 && <span
                        style={{
                            fontSize: '14px',
                            color: '#4165E3',
                            cursor: 'pointer'
                        }}
                        onClick={() => DeleteRow(r)}
                    >
                        删除
                    </span>}
                    <span
                        style={{
                            fontSize: '14px',
                            color: '#4165E3',
                            cursor: 'pointer',
                            marginLeft: '15px'
                        }}
                        onClick={() => AddRow(r)}
                    >
                        新增一行
                    </span>
                </>
        },
        {
            title: <span>车辆牌照 <span style={{ color: 'red' }}> *</span></span>,
            width: 120,
            dataIndex: 'licensePlate',
            editable: true,
            align: 'center'
        },
        {
            title: '车辆品牌',
            width: 140,
            dataIndex: 'vehicleBrand',
            editable: true,
            align: 'center'
        },
        {
            title: '车型',
            width: 120,
            dataIndex: 'vehicleModel',
            editable: true,
            align: 'center'
        },
        {
            title: <span>发动机号 <span style={{ color: 'red' }}> *</span></span>,
            width: 100,
            dataIndex: 'engineNumber',
            editable: true,
            align: 'center'
        },
        {
            title: '上牌日期',
            width: 120,
            dataIndex: 'registrationDate',
            editable: true,
            align: 'center',
            editType: 'datepicker'
        },
        {
            title: <span>Vin码 <span style={{ color: 'red' }}> *</span></span>,
            width: 120,
            dataIndex: 'vin',
            editable: true,
            align: 'center'
        },
        {
            title: '车辆动力',
            width: 120,
            dataIndex: 'vehiclePower',
            editable: true,
            editType: 'select',
            options: vehiclePowerList,
            align: 'center'
        },
        {
            title: '现场',
            width: 200,
            dataIndex: 'fleet',
            editable: true,
            editType: 'select',
            options: fleetData,
            align: 'center'
        },
        {
            title: '产权归属公司',
            width: 220,
            dataIndex: 'company',
            editable: true,
            editType: 'select',
            options: companyData,
            align: 'center'
        },
        {
            title: '创建人',
            width: 200,
            dataIndex: 'createUser',
            align: 'center'
            // editable: true,
        },
        {
            title: '所属车队',
            width: 200,
            dataIndex: 'vehicleSite',
            align: 'center',
            editable: userType === '超级管理员',
            editType: userType === '超级管理员' ? 'select' : '',
            options: [{
                label: '全部',
                value: '',
                type: '管理员'
            }, ...authData].filter((item) => item.type === '管理员'),
            render: (text: string) => userType === '超级管理员' ? authData.find((item) => item.value === text)?.label ?? '' : createUser
        }
    ]

    const newColumn = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: any, rowIndex: number) => ({
                colIndex: index + 1,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                editable: col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
                onInputEnter: col.onInputEnter
            })
        }
    })
    //内联编辑
    const handleSave = (row: any) => {
        const newData = [...dataSource]
        const index = newData.findIndex((item) => row.temporaryId === item.temporaryId)
        const item = newData[index]
        newData.splice(index, 1, {
            ...item, ...row,
            registrationDate: row.registrationDate ? moment(row.registrationDate).format('YYYY-MM-DD') : ''
        })
        setDataSource(newData)
    }


    const onOk = async () => {
        let errorList: any = []
        dataSource.forEach((item: any) => {
            if (item.licensePlate && item.engineNumber && item.vin) {
                return
            } else {
                errorList.push(item.licensePlate)
            }
        })
        if (errorList.length > 0) {
            return message.warning(`请补全${errorList}必填信息，再继续操作！`)
        }
        try {
            setSaveLoading(true)
            let { retData } = await vehicleService.insert(dataSource)
            setSaveLoading(false)
            setAddCarVisible(false)
            message.success(`添加成功！`)
            await loadData()
            return retData
        } catch (error) {
            setSaveLoading(false)
        }
    }

    const onClose = () => {

        globalPrompt('modal', {
            title: '新增车辆',
            type: 'warning',
            text: '您还有正在新增的车辆记录...是否关闭？',
            okText: '关闭页面',
            onOk: () => setAddCarVisible(false),
            cancelText: '继续添加',
            onCancel: () => {
                return
            }
        })
    }

    return (
        <YHModal visible={addCarVisible} title="您正在添加车辆..." cancelText="取消添加" okText="确定添加"
                 onCancel={onClose} onOk={onOk} width={'70%'} showFooter={true}>
            <Table
                loading={saveLoading}
                rowKey={(record) => record.temporaryId}
                columns={newColumn as ColumnsType<any>}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell
                    }
                }}
                dataSource={dataSource}
                scroll={{ x: 'max-content' }}
                pagination={false}
                bordered
                // footer={() => <span style={{ color: '#999999', cursor: 'pointer' }} onClick={() => AddRow()}><PlusOutlined />新增一行</span>}
            />
        </YHModal>
    )
}
